import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomError } from '@shared/controls/models/custom-error.model';
import { Constant } from '@shared/utilities/constant';

@Component({
  selector: 'app-custom-error',
  templateUrl: './custom-error.component.html',
  styleUrls: ['./custom-error.component.scss']
})
export class CustomErrorComponent implements OnInit {
  errorMessage: any;
  constructor(private router: Router) {
  
   }

  ngOnInit(): void {
  }
  callCustomErrorModel(){
    debugger;
    let newError = new CustomError('this is new error instance', 101);
    if(newError instanceof CustomError) {
      this.errorMessage = newError.alertError();
    }
  }
  loginbtnclick() {
    const clientId = sessionStorage.getItem(Constant.ClientId);
    if(clientId) {
     this.router.navigate(['/login', clientId]);
    } else {
     this.router.navigateByUrl('/login');
    }
  }

}
